var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShadowIconNine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4491_275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 0H0V66H66V0Z",
    fill: "#A2D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3991 51.1555H26.5951C26.0011 51.1555 25.5391 50.6935 25.5391 50.0995V32.9395C25.5391 30.8935 26.7931 29.3755 27.9151 27.9895C28.9051 26.8015 29.8291 25.6795 29.8291 24.4255V15.9115C29.8291 15.3175 30.2911 14.8555 30.8851 14.8555H35.1751C35.7691 14.8555 36.2311 15.3175 36.2311 15.9115V24.4255C36.2311 25.6795 37.1551 26.8015 38.1451 27.9895C39.2671 29.3755 40.5211 30.8935 40.5211 32.9395V50.0995C40.4551 50.6935 39.9931 51.1555 39.3991 51.1555Z",
    fill: "#ECE9DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9925 65.9993V45.2093L35.8965 15.1133C35.8965 15.1133 36.2265 15.4433 36.2265 15.8393V24.4193C36.2265 25.6733 37.1505 26.7953 38.1405 27.9833C39.2625 29.3693 40.5165 30.8873 40.5165 32.9333V50.0933C40.5165 50.6873 40.0545 51.1493 39.4605 51.1493H26.5905C26.3925 51.1493 26.1945 51.0833 26.0625 51.0173L41.0445 65.9993H65.9925Z",
    fill: "#78B3B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4491_275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowIconNine);
export default __webpack_public_path__ + "static/media/shadow-icon-nine.16371b94bd9ce6197a54f4202117fe02.svg";
export { ForwardRef as ReactComponent };